import { IIAMGroup } from "api/entities/iam-groups";
import SidePanelSection from "components/shared-ui/side-panel-section/side-panel-section";
import { useApi } from "utils/hooks/use-api";
import { iamService } from "api/services/iam";
import React, { useEffect, useState } from "react";
import styles from "./access-key-section.module.scss";
import tableStyles from "../../../../shared-ui/table/table.module.scss";
import {
  IIAMCredential,
  IIAMCredentialMeta,
} from "api/entities/iam-credentials";
import { IColumnDefinition } from "components/shared-ui/table/table";
import IAMCredentialStatusToggle from "components/access-credentials/access-credentials-table/status";
import { MoreOption } from "components/access-credentials/access-credentials-table/moreoption";
import { CompactTable } from "components/shared-ui/compact-table/compact-table";
import { AccessCodesGeneratedDialog } from "components/access-credentials/dialogs/access-codes-generated-dialog/access-codes-generated-dialog";

export interface IAccessKeysSectionProps {
  userName: string;
  isCreate?: boolean;
}

export default function AccessKeysSection(props: IAccessKeysSectionProps) {
  const [api] = useApi();

  const [accessKeys, setAccessKeys] = useState<IIAMCredentialMeta[]>([]);
  const [savedAccessKey, setSavedAccessKey] = useState<IIAMCredential>();
  const [isDialogOpen, setDialogOpen] = useState(false);

  const createAccessKey = () => {
    api(
      iamService
        .createAccessKey({ UserName: props.userName })
        .then((accessKey) => {
          setSavedAccessKey(accessKey);
          setDialogOpen(true);
        })
    );
  };

  const closeDialog = () => {
    setDialogOpen(false)
    fetchData()
  }
  const fetchData = () => {
    api(
      iamService
        .getAccessKeysForUser(props.userName)
        .then((page) => setAccessKeys(page.data))
    );
  };

  const columns: IColumnDefinition<IIAMCredentialMeta, null>[] = [
    {
      label: "Key",
      className: styles["col-key"],
      formatter: (row) => row.AccessKeyId,
    },
    {
      label: "Created AT",
      className: styles["col-created"],
      formatter: (row) => new Date(row.CreateDate).toLocaleString(),
    },
    {
      label: "Status",
      className: styles["col-status"],
      formatter: (row) => (
        <IAMCredentialStatusToggle data={row} refresh={fetchData} />
      ),
    },
    {
      label: "Manage",
      className: tableStyles["col--manage"],
      formatter: (row) => {
        return <MoreOption data={row} />;
      },
    },
  ];

  useEffect(() => {
    fetchData();
  }, [props.userName]);

  return (
    <SidePanelSection testId="group-section" title="User Access Keys">
      <CompactTable
        testId="storage-pool-nodes-table"
        className={styles.table}
        loading={false}
        columns={columns}
        rows={accessKeys}
        onAddClick={createAccessKey}
        addButtonCaption="Create Access Key"
      />
      <AccessCodesGeneratedDialog
        open={isDialogOpen}
        applicationCredentials={savedAccessKey}
        onClose={closeDialog}
      />
    </SidePanelSection>
  );
}
